import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// function in src/assets/js/main.js
declare let loadAcordion: Function;

@Component({
  selector: 'app-clabe-info-modal',
  templateUrl: './clabe-info-modal.component.html',
  styleUrls: ['./clabe-info-modal.component.css']
})
export class ClabeInfoModalComponent implements AfterViewInit {

  constructor(
    public modal: NgbActiveModal,
    @Inject(PLATFORM_ID) private platformId: any
  ) { }


  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      loadAcordion();
    }
  }

}
